module.exports = __webpack_public_path__ + "img/2_266.bca30e90.png";